export default function init() {
  const videos = document.querySelectorAll(
    '.VerticalContent__MediaContainer video',
  ) as NodeListOf<HTMLMediaElement>
  videos.forEach((video) => {
    updateControl(video)
    video.parentElement?.addEventListener('click', () =>
      togglePause(video, videos),
    )
    video.parentElement?.children[0].addEventListener('click', (e) => {
      e.stopPropagation()
      toggleMute(video, videos)
    })
    video.addEventListener('play', () => updateControl(video))
    video.addEventListener('pause', () => updateControl(video))
    video.addEventListener('volumechange', () => updateControl(video))
  })
}

const togglePause = (
  video: HTMLMediaElement,
  videos: NodeListOf<HTMLMediaElement>,
) => {
  if (video.paused) {
    videos.forEach((video) => video.pause())
    video.play()
  } else {
    video.pause()
  }
  updateControl(video)
}

const toggleMute = (
  video: HTMLMediaElement,
  videos: NodeListOf<HTMLMediaElement>,
) => {
  if (video.muted) {
    videos.forEach((video) => (video.muted = false))
  } else {
    videos.forEach((video) => (video.muted = true))
  }
  updateControl(video)
}

const updateControl = (video: HTMLMediaElement) => {
  if (video.paused) {
    video.parentElement?.classList.add('is-paused')
  } else {
    video.parentElement?.classList.remove('is-paused')
  }

  if (video.muted) {
    video.parentElement?.classList.add('is-muted')
  } else {
    video.parentElement?.classList.remove('is-muted')
  }
}
